import React from 'react';
import './about.css';

export default class About extends React.Component {
    render() {

        return (
            <div className="itemContainer" id="about">

                <div className="item">
                    <div className="ti-Line-Map-Pin-3 item-icon col-md-2"></div>
                    <div className="col-md-10">Apartmanunk Sárvár zöldövetezi részén, könnyen megközelíthető, csendes utcában helyezkedik el. 
    Közel a városközponthoz és a wellness fürdőhöz. 200 méteres körzetben  élelmiszerbolt (Penny, Spar), étterem, játszótér, 
    autóbusz pályaudvar, piac (hétfő, vasárnap) található. </div>
                </div>
                    
                <div className="item">
                    <div className="ti-Line-Home item-icon col-md-2"></div>
                    <div className="col-md-10">55 m2-en akár 6-7 fő részére tudunk kényelmes elhelyezést biztosítani. A 4 légterű (háló, nappali, 
                  konyha, fürdoszoba) apartman elsősorban családok számára ideális.
                   Igény esetén, két külön hálórész is kialakítható.
                    Mindkét helyiségben tv áll vendégeink rendelkezésére.</div>
                </div>
                    
                <div className="item">
                    <div className="ti-Line-Fire item-icon col-md-2"></div>
                    <div className="col-md-10">Vendégeink részére nagyméretű, jól felszerelt konyha áll rendelkezésre (hutő, mikró, gáztűzhely, kenyérpirító, kávéfoző, tányérok, edények). 
Az apartman területén korlátlan, ingyenes internetelérést (WIFI) biztosított.
Parkolásra a zárt udvarban van lehetőség, ahol hinta, mászóka, kerti pavilon, szalonnasütő, bográcsozó is található. 
Vonattal érkező vendégeinket (díjmentesen) a szállásra szállítjuk.</div>
                </div>

                <div className="item">
                    <div className="ti-Line-People-1 item-icon col-md-2"></div>
                    <div className="col-md-10">Apartmanunk családok számára ideális, akár 3 generáció is 
                    kellemes napokat tölthet el nálunk. De várjuk pár napra érkező, párok,
                     környéken dolgozó vagy átutazó vendégeinket is. Mi 1 éjszakára is szeretettel várjuk!</div>
                </div>

                <div className="item">
                    <div className="ti-Line-Credit-Card item-icon col-md-2"></div>
                    <div className="col-md-10">Vendégeinknek lehetőségük van fizetni készpénzzel, átutalással illetve SZÉP kártyával.</div>
                </div>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/content/about.js